import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { Grid } from '@/components/Grid';
import { NextImage } from '@/components/NextImage';
import { TaxedPrice } from '@/components/TaxedPrice';
import { Typography } from '@/components/Typography';

import { ReactComponent as CheckSvg } from '@/assets/icons/check-icon.svg';
import { ReactComponent as CloseSvg } from '@/assets/icons/close-icon.svg';

export const Wrapper = styled(Box)`
  width: 100%;
  position: absolute;
  top: 100%;

  ${({
    theme: {
      colors: { shadow2, white },
      components: { addToCartDialog },
      media,
      spacing,
    },
  }) => css`
    box-shadow: 0px 3px 6px ${shadow2};
    padding: ${spacing(2, 0)};
    background-color: ${white};
    left: 0;

    ${media.md.up} {
      right: 7%;
      width: ${addToCartDialog.width};
    }
  `}
`;

export const HeaderWrapper = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => theme.spacing(0, 2, 2, 2)};
`;

export const Header = styled(Flex)`
  align-items: center;
`;

export const HeaderText = styled(Typography)`
  padding-top: 4px;
  text-transform: uppercase;

  ${({ theme }) => css`
    font-family: ${theme.fontFamilies.italianPlate};
    font-size: ${theme.fontSizes.h5};
    font-weight: ${theme.fontWeights.bold};
    color: ${theme.colors.secondary};
  `}
`;

export const CheckIcon = styled(CheckSvg)`
  width: 24px;
  height: 24px;
  margin-right: ${({ theme }) => theme.spacing(1)};
`;

export const CloseButton = styled.button`
  all: unset;
  cursor: pointer;
  transform: translateX(5px);
`;

export const CloseIcon = styled(CloseSvg)`
  width: 24px;
  height: 24px;
`;

export const Body = styled(Grid)`
  grid-auto-rows: minmax(100px, auto);

  ${({ theme }) => css`
    border-top: 1px solid ${theme.colors.primaryAdd6};
    border-bottom: 1px solid ${theme.colors.primaryAdd6};
    padding: ${theme.spacing(2)};
  `}
`;

export const RowContent = styled(Flex)`
  width: 100%;
  justify-content: space-between;
  ${({ theme }) => css`
    padding-block: ${theme.spacing(1)};
    padding-left: ${theme.spacing(2)};
  `}
`;

export const AlreadyInBagText = styled(Typography)`
  width: 100%;
  text-align: center;
`;

export const ImageWrapper = styled(Box)`
  position: relative;
  height: auto;
  width: 64px;
`;

export const Image = styled(NextImage)<{ $scaleRatio?: number }>`
  object-fit: contain;

  ${({ $scaleRatio }) => css`
    transform: scale(${$scaleRatio});
  `}
`;

export const Sku = styled(Typography)`
  ${({ theme }) => css`
    color: ${theme.colors.secondaryGrey};
    font-family: ${theme.fontFamilies.italianPlate};
    font-size: ${theme.fontSizes.p3};
  `}
`;

export const Name = styled(Typography)`
  text-transform: uppercase;

  ${({ theme }) => css`
    color: ${theme.colors.secondary};
    font-family: ${theme.fontFamilies.italianPlate};
    font-size: ${theme.fontSizes.p1};
  `}
`;

export const AdditionalName = styled(Typography)`
  font-size: 0.688rem;
  color: ${({ theme }) => theme.colors.secondaryGrey};
`;

export const Price = styled(TaxedPrice)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.h5};
    font-family: ${theme.fontFamilies.italianPlate};
  `}
`;

export const Footer = styled(Flex)`
  justify-content: space-between;

  > a {
    width: 100%;
  }

  ${({ theme }) => css`
    padding: ${theme.spacing(2, 2, 0, 2)};
    gap: ${theme.spacing(2)};
  `}
`;
